module.exports = __webpack_public_path__ + "assets/img/af02898fe3f71feff33d9544c046b623.png";